import Drawer, {drawerClasses} from "@mui/material/Drawer";
import * as React from "react";
import Stack from "@mui/material/Stack";
import {CloseRounded} from "@mui/icons-material";
import {Box, Button, IconButton, Typography} from "@mui/material";
import {isValidElement, useMemo} from "react";
import {styled} from "@mui/material/styles";
import {AuthButtonVO} from "@/service/menu.s";
import {ApprovalButton} from "@/widget/ProcessApproval/ApprovalButton";
import {defaultDrawerModal, useDrawerModal, useGlobalActions} from "@/store/global.c";
import isEmpty from "lodash/isEmpty";

// TODO HEADER右边空间不够
const ScrollDrawerWrapper = styled(Box, {shouldForwardProp: (prop) => prop !== "headerheight" && prop !== 'hiddenfooter'})<{ headerheight?: number, hiddenfooter?: boolean }>(({
                                                                                                                                                                                   hiddenfooter,
                                                                                                                                                                                   headerheight
                                                                                                                                                                               }) => {
    let height = "calc(100vh - 139px)"
    if (hiddenfooter) {
        height = `calc(100vh - ${headerheight! + 31}px)`;
    }
    return ({
        margin: "16px 0px 13px 10px",
        paddingRight: '10px',
        paddingBottom: '3px',
        overflowY: "scroll",
        overflowX: "hidden",
        "::-webkit-scrollbar": {
            width: 10,
            height: 10,
        },
        height: height,
        "::-webkit-scrollbar-thumb": {
            [`& .${drawerClasses.paper}`]: {
                backgroundColor: "background.paper",
            },
            cursor: "pointer",
            borderRadius: "3px",
        },
        "&:hover::-webkit-scrollbar-thumb": {
            backgroundColor: "rgba(231,231,226)",
        },
    })
});

type HeaderButtonProps = {
    onButtonClick?: (row: any) => void;
    btns?: AuthButtonVO[]
}

type DrawerHeaderProps = {
    header: string | React.ReactNode;
    id?: number
    dialogBtnCallback?: (btn: AuthButtonVO) => void;
    onClose: () => void;
} & SlotDrawerProps & HeaderButtonProps & SlotDrawerHeaderProps;

type DrawerFooterProps = {
    onSubmit?: () => void;
    onReset?: () => void;
    loading?: boolean
};

export type SlotDrawerProps = {
    bodyWidth?: number
    headerHeight?: number
    hiddenFooter?: boolean
    viewBtnCallback?: (row: any) => SlotDrawerHeaderProps;
}

export type SlotDrawerHeaderProps = {
    title?: string
    instanceId?: number
    businessId?: number
    custom?: boolean
    body?: React.ReactNode
    updateForm?: React.ReactNode
    tags?: React.ReactNode
    switchButton?: React.ReactNode
    icon?: React.ReactNode
}

export const HeaderButtons = ({btns, instanceId, onButtonClick, businessId, updateForm}: HeaderButtonProps & SlotDrawerHeaderProps) => {
    return <>{btns?.map((btn, index) => <Button variant="outlined" onClick={() => onButtonClick!(btn)} disabled={btn.disabled} key={index}
                                                sx={{maxWidth: '88px', padding: "0px 4px", fontSize: 10, height: '2rem'}}
                                                size={'small'}>{btn.menuName}</Button>)}<ApprovalButton updateForm={updateForm} businessId={businessId}
                                                                                                        instanceId={instanceId!}/></>
}

export const DrawerHeader = ({
                                 dialogBtnCallback,
                                 updateForm,
                                 id,
                                 custom,
                                 btns,
                                 icon,
                                 header,
                                 onClose,
                                 headerHeight,
                                 title,
                                 tags,
                                 instanceId,
                                 businessId,
                                 switchButton
                             }: DrawerHeaderProps) => {
    const {setDialogModal} = useGlobalActions()
    const onButtonClick = (btn: AuthButtonVO) => {
        if (isValidElement(btn.body)) {
            setDialogModal({open: true, id, header: btn.menuName, body: btn.body, maxWidth: btn.maxWidth})
        } else {
            dialogBtnCallback && dialogBtnCallback(btn)
        }
    }

    return (
        <Stack
            paddingX={2}
            height={headerHeight}
            justifyContent={"space-between"}
            direction={"row"}
            borderBottom={"1px solid rgb(239, 237, 244)"}
            width={"100%"}
            alignItems={"center"}
        >
            {!custom ? <Typography fontWeight={500} variant="h6">
                    {header}
                </Typography> :
                <Stack direction={'column'} maxWidth={'50%'} pb={1} height={'inherit'} justifyContent={'space-around'}>
                    <Stack direction={'row'} spacing={1} height={38} alignContent={'center'} alignItems={'center'}>
                        <Stack direction={'row'} maxWidth={'80%'} spacing={0.5} alignItems={'center'} alignSelf={'center'} alignContent={'center'}>
                            {icon}
                            <Typography fontWeight={500} textOverflow={'ellipsis'} whiteSpace={'nowrap'} overflow={'hidden'} color={'textPrimary'}
                                        variant='overline'
                                        fontSize={16}>{title}</Typography>
                        </Stack>
                        {switchButton}
                    </Stack>
                    {tags}
                </Stack>}

            <Stack spacing={1} direction={'row'} alignItems={'center'} alignContent={'center'}>
                <HeaderButtons btns={btns} updateForm={updateForm} instanceId={instanceId} businessId={businessId} onButtonClick={onButtonClick}/>
                <IconButton
                    onClick={onClose}
                    sx={{borderRadius: "8px", border: "1px solid rgb(239, 237, 244)"}}
                >
                    <CloseRounded color={"action"}/>
                </IconButton>
            </Stack>
        </Stack>
    );
};

export const DrawerFooter = ({onSubmit, onReset, loading}: DrawerFooterProps) => {
    return (
        <Stack
            paddingX={2}
            height={54}
            position={"absolute"}
            bgcolor={'#fff'}
            bottom={0}
            left={0}
            borderTop={"1px solid rgb(239, 237, 244)"}
            right={0}
            justifyContent={"space-between"}
            direction={"row"}
            width={"100%"}
            alignItems={"center"}
        >
            <Button disabled={loading} loading={loading} variant={"outlined"} onClick={onReset}>
                重置
            </Button>
            <Button
                disableElevation={true}
                onClick={onSubmit}
                color={"info"}
                type={'submit'}
                disabled={loading} loading={loading}
                variant={"contained"}
            >
                保存
            </Button>
        </Stack>
    );
};

export default function DrawerModal() {
    const {
        open,
        header,
        body,
        btns,
        id,
        dialogBtnCallback,
        icon,
        switchButton,
        title,
        tags,
        updateForm,
        bodyWidth,
        custom,
        headerHeight = 54,
        hiddenFooter,
        instanceId,
        businessId
    } = useDrawerModal();
    const {setDrawerModal} = useGlobalActions();
    const onClose = () => {
        setDrawerModal(defaultDrawerModal);
    };

    const drawerWidth = useMemo(() => {
        if (!isEmpty(bodyWidth)) {
            return bodyWidth;
        }
        if (innerWidth >= 1580) {
            return 780
        } else if (innerWidth >= 1000 && innerWidth <= 1500) {
            return 620
        }
        return 580
    }, [innerWidth]);

    return (
        <Drawer
            anchor={"right"}
            slotProps={{
                paper: {
                    sx: {
                        borderLeft: "1px solid rgb(239, 237, 244)",
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                        boxShadow: "rgba(27, 27, 31, 0.07) 0px 1px 2px 0px",
                    },
                },
                backdrop: {sx: {background: "rgba(27, 27, 31, 0.2)"}},
            }}
            open={open}
            onClose={onClose}
        >
            <Box
                width={drawerWidth}
                position={"relative"}
                overflow={"hidden"}
                height={"100%"}
            >
                <DrawerHeader instanceId={instanceId} updateForm={updateForm} custom={custom} businessId={businessId} headerHeight={headerHeight} id={id} title={title} tags={tags}
                              dialogBtnCallback={dialogBtnCallback} icon={icon} switchButton={switchButton}
                              btns={btns} header={header} onClose={onClose}/>
                <ScrollDrawerWrapper headerheight={headerHeight} hiddenfooter={hiddenFooter}
                ><Box component={'div'} pl={'10px'}>{body}</Box></ScrollDrawerWrapper>
            </Box>
        </Drawer>
    );
}
